export class BemSubtipo {
  ativo: boolean; 
  id: number; 
  codigoTce: string; 
  subTipo: string; 
  tipoBemId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-subtipos/shared/bem-subtipo.model.ts
 **/